import { css } from '@adornis/chemistry/directives/css.js';
import { XLoader } from '@adornis/chemistry/elements/components/x-loader.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('tr-loader')
export class TrLoader extends XLoader {
  override render() {
    return html`
      <tr-flex space-between horizontal space="xxs" ${css({ position: 'absolute', bottom: '0', width: '100%' })}>
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
      </tr-flex>
    `;
  }

  override styles() {
    return [
      {
        width: '40px',
        height: '40px',
        position: 'relative',
        '.loading-dot': {
          width: '10px',
          height: '10px',
          background: '#000',
          borderRadius: '50%',
        },
        '.loading-dot:nth-child(1)': {
          animation: 'animate-dot-first 750ms ease 250ms infinite',
        },
        '.loading-dot:nth-child(2)': {
          animation: 'animate-dot-first 750ms ease 125ms infinite',
        },
        '.loading-dot:nth-child(3)': {
          animation: 'animate-dot-first 750ms ease 0s infinite',
        },
        '@keyframes animate-dot-first': {
          '0%': {
            transform: 'translateY(0)',
          },
          '30%': {
            transform: 'translateY(-8px)',
          },
          '60%': {
            transform: 'translateY(0)',
          },
        },
      },
    ];
  }
}
